import React from 'react'
import { Box } from '@mui/material'
import NextImage from 'next/image'
import { EmtButton, EmtModal, EmtTypography, useMobile } from 'emt-components-v2'
import NextALink from '@/components/NextALink'
import VariantImages from '@/assets/VariantImages'
import { TokenKeys } from '@/modules/Auth/LocalStorageHelper'
import { openUrlApp } from '@/utils'
import { useRouter } from 'next/router'
import { Routes } from '@/assets/configs'
import { useIsQueryOwner } from '@/hooks'

interface Props {
  open: boolean
  setOpen: (val: boolean) => void
}

const PetOwnerTransitionModal: React.FC<Props> = ({ open, setOpen }) => {
  const [isMobile] = useMobile()
  const router = useRouter()
  const [, , appendQueryType] = useIsQueryOwner()

  return (
    <EmtModal
      open={open}
      sx={{ '& .inner-box': { width: '600px', maxWidth: '90vw' }, '& .children-box': { padding: '32px' } }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
          textAlign: 'center',
        }}
      >
        <EmtTypography variant="h4" fontWeight={800}>
          Emprunte Mon Toutou Sitter devient Super Sitters
        </EmtTypography>
        <EmtTypography variant="body1">
          Notre service de pet sitting devient indépendant (le service de mise en relation avec les emprunteurs est
          toujours disponible sur Emprunte Mon Toutou). Votre compte est disponible sur supersitters.app avec le même
          email / mot de passe.{' '}
          {isMobile
            ? 'Téléchargez la nouvelle application :'
            : 'Cliquez ici pour être automatiquement connecté sur Super Sitters :'}
        </EmtTypography>

        {isMobile && (VariantImages.GooglePlay || VariantImages.AppStore) ? (
          <Box
            sx={{
              display: 'flex',
              marginTop: '15px',
              gap: '8px',
            }}
          >
            {VariantImages.AppStore && (
              <NextALink href={'https://apps.apple.com/fr/app/super-sitters/id6759970836'} title="appstore">
                <NextImage src={VariantImages.AppStore} alt={'App store'} width={150} style={{ maxWidth: '100%' }} />
              </NextALink>
            )}
            {VariantImages.GooglePlay && (
              <NextALink href={'https://play.google.com/store/apps/details?id=app.supersitters.app'} title="playstore">
                <NextImage
                  alt={'Google Play'}
                  src={VariantImages.GooglePlay}
                  width={150}
                  style={{ maxWidth: '100%' }}
                />
              </NextALink>
            )}
          </Box>
        ) : null}
        {isMobile && (
          <EmtTypography variant="body1">
            Après avoir téléchargé l’application, cliquez ici pour y être automatiquement connecté :
          </EmtTypography>
        )}
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '16px' }}>
          <EmtButton
            color="purple"
            size="large"
            onClick={(event: React.MouseEvent) => {
              event.preventDefault()
              event.stopPropagation()
              const url = `https://app.supersitters.app/pro?token=${encodeURIComponent(
                localStorage.getItem(TokenKeys.Auth ?? '') || '',
              )}&refreshToken=${encodeURIComponent(localStorage.getItem(TokenKeys.Refresh ?? '') || '')}&type=pro`
              openUrlApp(url)
            }}
            sx={{ width: '100%' }}
          >
            Se connecter sur Super Sitters
          </EmtButton>

          <EmtTypography
            variant="body2"
            sx={{
              fontWeight: 700,
              color: '#AE59C5',
              lineHeight: '1.1',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
            onClick={() => {
              router.push(appendQueryType(Routes.Home))
              setOpen(false)
            }}
          >
            Retour sur Emprunte Mon Toutou
          </EmtTypography>
        </Box>
      </Box>
    </EmtModal>
  )
}

export default PetOwnerTransitionModal
